"use client"

import { create } from "zustand"

// Chrome's beforeinstallprompt event, captured at module init (see
// lib/install-prompt-listener.ts) and stashed here so the install sheet's
// CTA can fire .prompt() even if the user landed on a screen mounted after
// the event fired.
export type BeforeInstallPromptEvent = Event & {
  prompt: () => Promise<void>
  userChoice: Promise<{ outcome: "accepted" | "dismissed" }>
}

interface PwaState {
  deferredPrompt: BeforeInstallPromptEvent | null
  installPromptCaptured: boolean
  swUpdateReady: boolean
  setDeferredPrompt: (e: BeforeInstallPromptEvent | null) => void
  setSwUpdateReady: (v: boolean) => void
}

// Runtime-only — nothing here is worth persisting across reloads. The 7-day
// install dismiss still uses localStorage (psc-install-dismissed) and the
// session dismiss for the SW update banner uses sessionStorage.
export const usePwaStore = create<PwaState>((set) => ({
  deferredPrompt: null,
  installPromptCaptured: false,
  swUpdateReady: false,
  setDeferredPrompt: (e) =>
    set({ deferredPrompt: e, installPromptCaptured: e !== null }),
  setSwUpdateReady: (v) => set({ swUpdateReady: v }),
}))
